import styled from 'styled-components';

type TWrapperProps = {
  $compact?: boolean;
};

export const Wrapper = styled.div<TWrapperProps>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.$compact ? 0 : '15px')};
  cursor: default;
  ${(props) =>
    props.$compact
      ? ''
      : `
    min-height: 300px;
    min-width: 0;
    width: 300px;
    max-width: calc(100vw - 32px);
  `}

  .label {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    padding: 0 0 15px;
    color: var(--color-text-muted);
  }

  .datepicker-wrapper {
    padding: 0 0 12px;
  }

  .job-type-wrapper {
    display: flex;
    gap: 20px;
  }

  .duration-wrapper {
    display: flex;
    gap: 12px;
    padding: 0 0 12px;
  }

  .duration-error {
    font-size: 12px;
    font-weight: 500;
    padding: 0 0 12px;
    color: var(--color-error-heading);
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    padding: 0 0 12px;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    color: var(--color-text-muted);
  }
`;
